import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    margin-top: 24px;
    padding: 0px 16px;
  `,
  label: css`
    margin-top: 32px;
  `,
  section: css`
    background-color: ${colors.platinum};
    border-radius: 10px;
    padding: 0px 16px;
    margin: 12px 0px 32px 0px;
  `,
  sectionItem: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 0px;
    & + div {
      border-top: 1px solid ${colors.mercury};
    }
  `,
  switchInput: css`
    & .MuiSwitch-track {
      opacity: 1;
      background: ${colors.charcoal};
    }
    & .MuiSwitch-switchBase.Mui-checked {
      color: ${colors.jungle} !important;
      + .MuiSwitch-track {
        background: ${colors.mint600};
      }
    }
  `,
};

export default styles;
